import component from './DateRangeSelector';

export default component;
